import {
  IncentiveOffer,
  IncentiveOfferStatus,
} from 'modules/incentivesMarket/types';

import { getOfferStatus } from './getOfferStatus';

export type IncentiveOfferManageVisibilityParams = {
  offer: IncentiveOffer;
  isAdmin: boolean;
  userBeneficiaryIds: string[];
  publisherCifGroupIds?: string[];
};

export const getIncentiveOfferManageActionsVisibility = ({
  offer,
  isAdmin,
  userBeneficiaryIds,
  publisherCifGroupIds = [],
}: IncentiveOfferManageVisibilityParams): {
  canModify: boolean;
  canCancel: boolean;
} => {
  if (offer.canceledAt) {
    return { canModify: false, canCancel: false };
  }

  if ((offer.unitsCount?.agreed ?? 0) > 0) {
    return { canModify: false, canCancel: false };
  }

  const publisherId =
    typeof offer.beneficiary === 'string'
      ? offer.beneficiary
      : offer.beneficiary?._id || '';
  const publisherIdStr = publisherId ? String(publisherId) : '';

  const cifGroupIds =
    publisherCifGroupIds.length > 0 ? publisherCifGroupIds : [publisherIdStr];

  const isPublisher = userBeneficiaryIds.some((id) => cifGroupIds.includes(id));

  if (!isAdmin && !isPublisher) {
    return { canModify: false, canCancel: false };
  }

  const status = getOfferStatus(offer);

  if (status === IncentiveOfferStatus.ACCEPTED) {
    return { canModify: false, canCancel: false };
  }

  const canCancel =
    status === IncentiveOfferStatus.ACTIVE ||
    status === IncentiveOfferStatus.EXPIRED;

  const canModify = status === IncentiveOfferStatus.ACTIVE;

  return { canModify, canCancel };
};
